<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on">
        <v-icon class="pr-1">mdi-account</v-icon>
        <span class="pr-1 text-none ">{{ nombreOperador }}</span>
        <v-icon small>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item :href="configurationUrl" target="_blank">
        <v-list-item-action>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-action>
        <v-list-item-title>Configuraciones</v-list-item-title>
      </v-list-item>
      <v-list-item @click="handleLogout">
        <v-list-item-action>
          <v-icon>mdi-power</v-icon>
        </v-list-item-action>
        <v-list-item-title>Cerrar Sesión</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import SessionService from '@/services/SessionService'
  import {CONFIGURATION_URL, LOGOUT_URL, SITE_NAME} from '@/config'

  export default {
    name: 'FhMenuOperador',
    computed: {
      nombreOperador() {
        return SessionService.getNombreOperador()
      },
      configurationUrl() {
        return CONFIGURATION_URL
      }
    },
    methods: {
      handleLogout() {
        location.href = `${LOGOUT_URL}?nombre=${SITE_NAME}&redirect=${location.origin}`
      }
    }
  }
</script>

<style scoped>

</style>
